export enum StatoIntervento {
  SENZA_STATO = 'SENZA STATO',
  DA_ASSEGNARE = 'DA ASSEGNARE',
  ASSEGNATO = 'ASSEGNATO',
  PRESO_IN_CARICO = 'PRESO IN CARICO',
  CHIUSO = 'CHIUSO',
  VALIDATO = 'VALIDATO'
}
